import template from './honeyAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.brokerId = '';
              self.confirm = () => {
                $mdDialog.hide({ brokerId: self.brokerId });
              };
              self.cancel = () => {
                $mdDialog.hide();
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
